import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../index.css";

const AboutDeveloper = () => {
  const { handleShowModal } = useGlobalContext();
  return (
    <section className="section shadow-sm lazyloaded" id="developer">
      {/* <div className="d-block pt-2 pb-1 text-center">
        <img
          src="images/lnt-logo.webp"
          width="auto"
          height="100%"
          loading="lazy"
          alt="lnt realty"
        />
      </div> */}
      <div className="row">
        <div className="col-md-8">
          <h1 class="d-block section-heading color-primary text-capitalize">
            About Developer
          </h1>
        </div>
        <div className="col-md-4">
          <button
            className="btn btn-info micro-form-btn enqModal effetMoveGradient effectScale download_brochure float-lg-right d-none d-lg-block"
            onClick={() => handleShowModal("AboutDev ChatWithUs")}
          >
            Chat with us
          </button>
        </div>
      </div>

      <p>
        L&T Realty, the real estate arm of the globally trusted Larsen & Toubro,
        brings the group's 80+ years of nation-building expertise to India's
        real estate landscape. Established in 2011, L&T Realty has delivered
        over 4.4 million sq. m. of premium residential spaces across major
        metros.
        <br />
        Known for engineering precision, architectural excellence, and
        sustainability, the brand is a benchmark in gated communities and
        mixed-use developments — serving over 10,000+ happy families and
        expanding across Mumbai, Navi Mumbai, NCR, Bengaluru, Hyderabad, and
        Chennai.
      </p>

      <div class="rera-numbers">
        <div class="rera-item">
          <img src="images/rera-P51900046369.webp" alt="rera qr" />
          <strong>P51900046369</strong>
        </div>
      </div>

      <span className="pro-rera text-center-mob">
        L&T Realty Island Cove has been registered via MahaRERA registration
        number and is available on the website{" "}
        <a href="https://maharera.mahaonline.gov.in/">
          https://maharera.mahaonline.gov.in/
        </a>{" "}
        under registered projects.
      </span>

      <p></p>
      <button
        className="btn btn-info micro-form-btn enqModal effetMoveGradient effectScale download_brochure float-lg-right mx-sm-auto d-lg-none"
        data-form="lg"
        data-title=" Chat with us"
        data-btn=" Chat with us"
        data-enquiry="Download Brochure Left Panel"
        data-redirect="enquiry"
        data-toggle="modal"
        data-target="#enqModal"
        onClick={() => handleShowModal("AboutDev ChatWithUs")}
      >
        Chat with us
      </button>
    </section>
  );
};

export default AboutDeveloper;
